import {AddNode} from './AddNode';
import {NODE_ROLES} from '../../const';

class AddAccessSwitch extends AddNode {
  icon = 'exchange';
  tooltip = 'Add Access Switch';
  visible = () => !this.rackEditorStore?.rackStore?.isRailCollapsed;
  onClick = () => {
    this.createNode(NODE_ROLES.ACCESS_SWITCH);
  };
}

export {AddAccessSwitch};
